import { Header } from '@/widgets/header/header';
import { ScrollTop } from '@/shared/scroll-top/scroll-top';
import { AppPlatform } from '@/widgets/mobile-app/app-platform';
import { CookiesAgreement } from '@/widgets/cookies-agreement/cookies-agreement';
import { CodeForm } from '@/features/authorization/code-form/code-form';
import { AuthorizationForm } from '@/features/authorization/authorization-form/authorization-form';
import { AuthorizationTel } from '@/features/authorization/authorization-tel/authorization-tel';
import { ModalCities } from '@/features/modal/modal-cities/modal-cities';
import { ModalVideo } from '@/features/modal/modal-video/modal-video';
import { footerTapbarCart } from '@/widgets/footer/footer-tapbar/footer-tapbar-cart.js';

window.addEventListener('DOMContentLoaded', () => {
	new Header();
	new CookiesAgreement();
	new ScrollTop(document.querySelector('.js-scroll-top'));
	new ModalCities(document.querySelector('.js-modal-cities'));
	new ModalVideo(document.querySelector('.js-modal-video'));
	document.querySelectorAll('.js-app-platform').forEach((element) => new AppPlatform(element));

	window.app.loginTelCode = new CodeForm(document.querySelector('#login-tel-code'));
	window.app.loginEmailCode = new CodeForm(document.querySelector('#login-email-code'));
	window.app.loginTelForm = new AuthorizationForm(document.querySelector('#login-tel-form'));
	window.app.loginEmailForm = new AuthorizationForm(document.querySelector('#login-email-form'));
	window.app.loginTel = new AuthorizationTel(document.querySelector('#login-tel'));
	window.app.loginEmail = new AuthorizationTel(document.querySelector('#login-email'));

	footerTapbarCart();
});
